<template>
  <div class="navbar" :style="ishand?'background: #fff;':''">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container"
               @toggleClick="toggleSideBar"/>

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container"/>
    <div v-if="!flag" class="userName">您好：{{userName}}</div>
    <div class="right-menu">
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper" :style="ishand?'':'margin-top: 3px;'">
          <img v-if="ishand" :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar" alt=""/>
          <img v-else src="@/img/hand.jpg" class="user-avatar" alt="">
          <i class="el-icon-caret-bottom" :style="ishand?'':'top: 20px;font-size: 19px;'" />
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <router-link to="/">
              <el-dropdown-item>首页</el-dropdown-item>
            </router-link>
           <!-- <index-link to="/user/profile">
             <el-dropdown-item>个人中心</el-dropdown-item>
           </index-link>
           <el-dropdown-item v-on:click="setting = true">
             <span>布局设置</span>
           </el-dropdown-item> -->
           <el-dropdown-item divided @click="upPassword">
              <span>修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item divided v-on:click="logout">
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <el-dialog
        v-model="dialogVisible"
        :close-on-click-modal="false"
        @close="cancel"
        title="修改密码"
        width="30%"
      >
        <el-form ref="form" :model="form" :rules="rules" label-width="90px">
          <el-form-item label="旧密码" prop="password">
            <el-input v-model="form.password"  placeholder="请输入旧密码" />
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input v-model="form.newPassword" show-password  placeholder="请输入新密码" />
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="submit"
              >保存</el-button
            >
          </span>
        </template>
      </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from './Breadcrumb'
import Hamburger from './Hamburger'
import {upPassword} from "@/api/login"

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data(){
    return {
      ishand:false,
      userName:undefined,
      flag:false,
      dialogVisible:false,
      form:{
        password:undefined,
        newPassword:undefined
      },
      rules: {
        password: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
      }
    }
  },
  created(){
    if(process.env.NODE_ENV === "development") {
      this.ishand=false;
    }else if(process.env.NODE_ENV === "production"){
      this.ishand=false;
    }else{
      this.ishand=true;
    }
    this.userName=localStorage.getItem("userName")
    this._isMobile()
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ]),
    setting: {
      get () {
        return this.$store.state.settings.showSettings
      },
      set (val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    }
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('toggleSideBar')
    },
    async logout () {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          location.reload()
        })
      })
    },
    upPassword(){
      this.dialogVisible=true
    },
    cancel(){
      this.dialogVisible=false;
      this.$refs.form.resetFields()
    },
    submit(){
      this.$refs.form.validate(valid=>{
        if(valid){
          upPassword(this.form).then(res => {
            if (res.code === 200) {
              this.$message.success('修改密码成功')
            }
          }).finally(() => {
            this.dialogVisible=false;
          })
        }
      })
    },
    _isMobile() {
      this.flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background-image: linear-gradient(120deg, #fdfbfb 0%, #f7f7f7 100%);
  box-shadow: 0 1px 1px rgba(0, 21, 41, .08);

  .userName{
    position: absolute;
    right: 100px;
    top: 12px;
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
    ::v-deep .el-dropdown {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
